import { dataGrip } from '../model/schemes/dataGrip';
import { dbeaver } from '../model/schemes/dbeaver';
import { jamScheme } from '../model/schemes/jam';
import { ssmsAds } from '../model/schemes/ssmsAds';
import { vscodeMssql } from '../model/schemes/vscodeMssql';
import type { KeybindingScheme, SchemeId } from '../model/keybindingTypes';

/**
 * Schemes the store can switch to, in the order the scheme picker lists them.
 * A persisted or imported id with no entry normalizes to 'jam' on hydration
 * and `setScheme` ignores it.
 */
export const availableKeybindingSchemes: Readonly<Partial<Record<SchemeId, KeybindingScheme>>> = {
  jam: jamScheme,
  'ssms-ads': ssmsAds.scheme,
  datagrip: dataGrip.scheme,
  dbeaver: dbeaver.scheme,
  'vscode-mssql': vscodeMssql.scheme,
};

export function schemeFor(
  schemeId: SchemeId,
  schemes: Readonly<Partial<Record<SchemeId, KeybindingScheme>>>,
): KeybindingScheme {
  return schemes[schemeId] ?? jamScheme;
}
